module.exports = __webpack_public_path__ + "static/img/txt_2.604fbe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/txt_2.png
// module id = TMqC
// module chunks = 1